module.exports = __webpack_public_path__ + "img/line-go.b6d79af6.png";